import React, { FC, useState } from "react"
import { ModalPostInstallPrompt } from "./ModalPostInstallPrompt"
import { RegistrationModal } from "./RegistrationModal"

// Coordinates the one-time login prompts so they appear in the right order: the
// User Agreement (EULA) first, then the on-prem registration modal once the EULA
// is settled for this admin.
export const LoginFlowModals: FC = () => {
    const [eulaResolved, setEulaResolved] = useState(false)
    return (
        <>
            <ModalPostInstallPrompt onEulaResolved={() => setEulaResolved(true)} />
            <RegistrationModal eulaResolved={eulaResolved} />
        </>
    )
}
